import { Injectable } from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { NetworkService } from '../services/ui/network.service';

/**
 * NetworkInterceptor
 *
 * Blocks ALL outgoing HTTP requests when the application is offline.
 * This prevents unnecessary failed requests, queue buildup, and
 * ensures the UI remains in a consistent state during disconnection.
 *
 * IMPORTANT: This interceptor should be registered FIRST in the
 * interceptor chain (before auth and error interceptors) so it
 * short-circuits before any other processing.
 */
@Injectable()
export class NetworkInterceptor implements HttpInterceptor {
  constructor(private readonly networkService: NetworkService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!this.networkService.isOnline) {
      return throwError(
        () =>
          new HttpErrorResponse({
            error: {
              message: 'Sin conexión a internet. Esperando reconexión...',
            },
            status: 0,
            statusText: 'Offline',
            url: request.url,
          }),
      );
    }

    return next.handle(request);
  }
}

export const networkInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: NetworkInterceptor, multi: true },
];
